/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import { EventEmitter } from '@nile/components';
import { Banner, BannerStatus } from '@superops/ui-design-system';
import { FormattedMessage } from 'react-intl';

const BannerComponent = ({
  bannerKey,
  defaultMessage = 'Banner info!',
  onBannerChange
}: {
  bannerKey: string;
  defaultMessage?: string;
  onBannerChange?: (showBanner: boolean) => void;
}) => {
  const [showBanner, setShowBanner] = useState<boolean>(false);
  const [status, setStatus] = useState<BannerStatus>('info');
  const [message, setMessage] = useState<string>(null);

  function handleEventMessage(data) {
    if (data?.message) {
      setMessage(data?.message);
    }
    if (data?.status) {
      setStatus(data?.status);
    }
    setShowBanner(!showBanner);
  }

  useEffect(() => {
    EventEmitter.subscribe(bannerKey, handleEventMessage);
    return () => {
      EventEmitter.unsubscribe(bannerKey);
    };
  }, []);

  function onBannerClose() {
    setShowBanner(false);
    EventEmitter.dispatch('bannerCloseEvent');
  }

  useEffect(() => {
    if (onBannerChange) {
      onBannerChange(showBanner);
    }
  }, [showBanner]);

  return showBanner ? (
    <div className="fx actr mb10">
      <Banner
        isClose
        alignContent="left"
        status={status || 'info'}
        onDismiss={onBannerClose}
      >
        <FormattedMessage id={message || defaultMessage} />
      </Banner>
    </div>
  ) : null;
};

export default BannerComponent;
